import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import AboutMe from '../pages/AboutMe';
import Porfolio from '../pages/Porfolio';
import NotFound from '../pages/NotFound';
import Other from '../pages/porfolio-pages/Other';
import OdlWeb from '../pages/porfolio-pages/other-pages/OldWeb';
import VideoGame from '../pages/porfolio-pages/other-pages/VideoGame';
import BI from '../pages/porfolio-pages/other-pages/BI';
import Desktop from '../pages/porfolio-pages/other-pages/Desktop';
import RunOrDie from '../pages/porfolio-pages/other-pages/old-proyects/RunOrDie';
import Business from '../pages/porfolio-pages/other-pages/old-proyects/Business';
import Cinegondb from '../pages/porfolio-pages/other-pages/old-proyects/Cinegodb';
import Kanjabandb from '../pages/porfolio-pages/other-pages/old-proyects/Kanjabandb';
import GameOverWebdb from '../pages/porfolio-pages/other-pages/old-proyects/GameOverWebdb';
import Kanjaban from '../pages/porfolio-pages/other-pages/old-proyects/kanjaban';
import Cinegon from '../pages/porfolio-pages/other-pages/old-proyects/Cinegon';
import PizzaHot from '../pages/porfolio-pages/other-pages/old-proyects/PizzaHot';
import GameOverWeb from '../pages/porfolio-pages/other-pages/old-proyects/GameOverWeb';
import OdlWebUno from '../pages/porfolio-pages/other-pages/old-proyects/OldWebUno';
import OdlWebDos from '../pages/porfolio-pages/other-pages/old-proyects/OldWebDos';
import Webs from '../pages/porfolio-pages/web-dev/Webs';
import Yoga from '../pages/porfolio-pages/web-dev/list-web/Yoga';
import Yugioh from '../pages/porfolio-pages/web-dev/list-web/Yugioh';
import Pokedex from '../pages/porfolio-pages/web-dev/list-web/Pokedex';
import Tusalud from '../pages/porfolio-pages/web-dev/list-web/Tusalud';
import Merry from '../pages/porfolio-pages/web-dev/list-web/Merry';
import Iphone from '../pages/porfolio-pages/web-dev/list-web/Iphone';
import Card from '../pages/porfolio-pages/web-dev/list-web/Card';
import Anime from '../pages/porfolio-pages/web-dev/list-web/Anime';
import Rym from '../pages/porfolio-pages/web-dev/list-web/Rym';

import ReactGA from 'react-ga';


function App() {

  const TRACKING_ID = "G-MQPCX3W886";
  ReactGA.initialize(TRACKING_ID);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/porfolio-v3.0" element={<AboutMe />} exact />
            <Route path="/porfolio" element={<Porfolio />} exact />

            <Route path="/web-development" element={<Webs />} exact />
            <Route path="/other-proyects" element={<Other />} exact />

            <Route path="/old-web-pages" element={<OdlWeb />} exact />
            <Route path="/desktop" element={<Desktop />} exact />
            <Route path="/data-base" element={<BI />} exact />
            <Route path="/video-games" element={<VideoGame />} exact />

            <Route path="/run-or-die" element={<RunOrDie />} exact />
            <Route path="/business-intelligence" element={<Business />} exact />
            <Route path="/kanjaban-db" element={<Kanjabandb />} exact />
            <Route path="/cinegon-db" element={<Cinegondb />} exact />
            <Route path="/gameoverweb-db" element={<GameOverWebdb />} exact />
            <Route path="/kanjaban" element={<Kanjaban />} exact />
            <Route path="/cinegon" element={<Cinegon />} exact />
            <Route path="/old-v2" element={<OdlWebDos />} exact />
            <Route path="/old-v1" element={<OdlWebUno />} exact />
            <Route path="/game-over-web" element={<GameOverWeb />} exact />
            <Route path="/pizza-hot" element={<PizzaHot />} exact />


            <Route path="/merry-christmas" element={<Merry />} exact />
            <Route path="/calm-yoga" element={<Yoga />} exact />
            <Route path="/tu-salud" element={<Tusalud />} exact />
            <Route path="/anime-sticker" element={<Anime />} exact />
            <Route path="/editable-3d-card" element={<Card />} exact />
            <Route path="/iphone-3d" element={<Iphone />} exact />
            <Route path="/pokedex" element={<Pokedex />} exact />
            <Route path="/rick-and-morty-versus" element={<Rym />} exact />
            <Route path="/learn-yugioh" element={<Yugioh />} exact />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;